import React, { useState } from 'react';

export default function FighterCard({ fighter, side }) {
  const [imgError, setImgError] = useState(false);
  if (!fighter) return null;

  const isF2     = side === 'f2';
  const hasImage = fighter.image_url && fighter.image_url.length > 5 && !imgError;

  const initials = (fighter.full_name || '')
    .split(' ')
    .map(w => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="fighter-card-wrap">

      {/* Image — z-index 1, overflows above card */}
      {hasImage && (
        <img
          className={`fighter-hero-img ${isF2 ? 'flip' : ''}`}
          src={fighter.image_url}
          alt={fighter.full_name}
          onError={() => setImgError(true)}
        />
      )}

      {/* Wrap overlay — z-index 2, covers FULL image including overflowing head */}
      {hasImage && (
        <div className={`fighter-wrap-overlay ${isF2 ? 'f2' : 'f1'}`} />
      )}

      {/* Card box — z-index 3, clips its own background/gradient */}
      <div className={`fighter-header-card ${side}`}>

        {!hasImage && (
          <div className={`fighter-hero-initials ${isF2 ? 'f2' : 'f1'}`}>
            {initials}
          </div>
        )}

        {/* Inner card gradient for text readability */}
        <div className={`fighter-hero-overlay ${isF2 ? 'f2' : 'f1'}`} />

        {/* Info pinned to bottom */}
        <div className="fighter-header-content">
          <div className="fighter-header-name">{fighter.full_name}</div>
          {fighter.nickname && (
            <div className="fighter-header-nickname">"{fighter.nickname}"</div>
          )}
          <div className={`fighter-header-record ${isF2 ? 'f2' : ''}`}>
            {fighter.wins}-{fighter.losses}{fighter.draws > 0 ? `-${fighter.draws}` : ''}
          </div>
          <div className="fighter-header-meta">
            {fighter.weight_class}
            {fighter.belt === 'Yes' && ' 🏆'}
            {fighter.height && ` · ${fighter.height}"`}
            {fighter.reach && ` · ${fighter.reach}" reach`}
            {fighter.stance && ` · ${fighter.stance}`}
          </div>
          {fighter.style && (
            <div className="style-badge">{fighter.style}</div>
          )}
        </div>
      </div>
    </div>
  );
}
